import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { InspectionPointService } from '../../shared/services/index';
import { InspectionPoint } from '../../shared/models/index';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseModalPageComponent } from '../../base-modal.component';

@Component({
    templateUrl: './new.component.html',
    standalone: false
})
export class NewPointPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  sectionId: string;
  folderId: string;
  public processing = false;

  constructor(
    location: Location,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private pointService: InspectionPointService
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pointId = params['sectionId'];
      if (pointId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.sectionId = pointId;

      this.folderId = params['folderId'];

      this.initData();
    });
  }

  initData(): void {}

  create(point: InspectionPoint): void {
    this.processing = true;
    if (this.folderId) {
      this.pointService
        .createPointInFolder(this.inspectionId, this.sectionId, this.folderId, {
          name: point.name,
          description: point.description
        })
        .subscribe((el) => {
          this.processing = false;
          this.goToBack();
        });
    } else {
      this.pointService
        .createPoint(this.inspectionId, this.sectionId, { name: point.name, description: point.description })
        .subscribe((el) => {
          this.processing = false;
          this.goToBack();
        });
    }
  }

  cancel(): void {
    this.goToBack();
  }
}
